import React from 'react';
import { motion } from 'framer-motion';
import { FaDownload, FaMusic, FaVideo } from 'react-icons/fa';

const DownloadButtons = ({ links }) => {
  if (!links || links.length === 0) return null;

  const audioLinks = links.filter(link => link.type === 'audio');
  const videoLinks = links.filter(link => link.type === 'video');

  const handleDownload = (url) => {
    window.open(url, '_blank');
  };

  const DownloadButton = ({ link, index }) => {
    const getQualityLabel = () => {
      if (link.type === 'audio') {
        return 'Audio (MP3)';
      }
      if (link.resolution) {
        const resolutionMap = {
          sd: 'SD Quality',
          hd: 'HD Quality',
          '360p': '360p',
          '480p': '480p',
          '720p': '720p',
          '1080p': '1080p',
        };
        return `Video (${resolutionMap[link.resolution] || link.resolution})`;
      }
      return 'Video (Best Quality)';
    };

    return (
      <motion.button
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: index * 0.1 }}
        onClick={() => handleDownload(link.download_url)}
        className="flex items-center justify-between p-4 bg-gray-800 hover:bg-gray-700 rounded-xl transition-all group"
        whileHover={{ scale: 1.02, x: 5 }}
        whileTap={{ scale: 0.98 }}
      >
        <div className="flex items-center gap-3">
          <div className="p-2 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg">
            <FaDownload className="text-white" />
          </div>
          <div className="text-left">
            <p className="text-white font-semibold">
              {getQualityLabel()}
            </p>
            {link.size && (
              <p className="text-gray-400 text-sm">{link.size}</p>
            )}
          </div>
        </div>
        <motion.div
          className="text-purple-400"
          animate={{ x: [0, 5, 0] }}
          transition={{ duration: 1, repeat: Infinity }}
        >
          →
        </motion.div>
      </motion.button>
    );
  };

  return (
    <div className="w-full max-w-3xl mx-auto space-y-6">
      {audioLinks.length > 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="bg-gray-900 rounded-2xl p-6"
        >
          <div className="flex items-center gap-3 mb-4">
            <FaMusic className="text-pink-500" size={24} />
            <h3 className="text-xl font-bold text-white">Audio Downloads</h3>
          </div>
          <div className="space-y-3">
            {audioLinks.map((link, index) => (
              <DownloadButton key={index} link={link} index={index} />
            ))}
          </div>
        </motion.div>
      )}

      {videoLinks.length > 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="bg-gray-900 rounded-2xl p-6"
        >
          <div className="flex items-center gap-3 mb-4">
            <FaVideo className="text-purple-500" size={24} />
            <h3 className="text-xl font-bold text-white">Video Downloads</h3>
          </div>
          <div className="space-y-3">
            {videoLinks.map((link, index) => (
              <DownloadButton key={index} link={link} index={index} />
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default DownloadButtons;
